<div
  *ngIf="content"
  class="ancillary-link flex flex-col mt-[16px] gap-[16px] tablet:gap-24 laptop:flex-row"
  [ngClass]="{ 'laptop:mt-[32px]': content.hasTrips }"
  id="mach-core-ancillary-link-container"
  data-acdl-page-section="header:my trips"
>
  <a
    #deltaViewAllTrips
    *ngIf="content.hasTrips"
    href="javascript:void(0)"
    (click)="viewAllTrips(); analyticsEvent.emit(deltaViewAllTrips)"
    [attr.aria-label]="content.viewAllTrips"
    class="ancillary-link__item link link-sm"
    id="mach-core-ancillary-view-all-trips"
    data-acdl-name="delta view all trips"
    data-acdl-action="header:my trips:"
  >
    {{ content.viewAllTrips }}
  </a>
  <a
    #deltaFindMyTrips
    *ngIf="content.hasTrips && displayLink"
    href="javascript:void(0)"
    (click)="displaySearchComponent(); analyticsEvent.emit(deltaFindMyTrips)"
    [attr.aria-label]="content.findMyTrips"
    class="ancillary-link__item link link-sm"
    id="mach-core-ancillary-find-trips"
    data-acdl-name="delta find trips"
    data-acdl-action="header:my trips:"
  >
    {{ content.findMyTrips }}
  </a>
  <a
    #deltaStays
    [href]="content.hotelReservation.url"
    (click)="analyticsEvent.emit(deltaStays)"
    target="_blank"
    rel="noopener noreferrer"
    [attr.aria-label]="content.hotelReservation.label"
    class="ancillary-link__item link link-sm"
    id="mach-core-ancillary-hotel-link"
    data-acdl-name="delta stays"
    data-acdl-action="header:my trips:"
  >
    {{ content.hotelReservation.label }}
    <span class="link-external-link-icon"></span>
  </a>
  <a
    #deltaCars
    [href]="content.carReservation.url"
    (click)="analyticsEvent.emit(deltaCars)"
    target="_blank"
    rel="noopener noreferrer"
    [attr.aria-label]="content.carReservation.label"
    class="ancillary-link__item link link-sm"
    id="mach-core-ancillary-car-link"
    data-acdl-name="delta car rentals"
    data-acdl-action="header:my trips:"
  >
    {{ content.carReservation.label }}
    <span class="link-external-link-icon"></span>
  </a>
</div>
